export default __webpack_public_path__ + "media/images/logo-fb34bcb7fd0ba1f3829c055164491bf3.svg";